import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import * as _ from 'lodash';

import { AuthenticationService } from "app/services/authentication.service";
import { VersionService } from "app/services/version.service";
import { User } from 'app/models/user';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  roles: User.Role[];
}
export const ROUTES: RouteInfo[] = [
  { path: '/call/list', title: 'Обращения', icon: 'assignment', class: '', roles: null },
  { path: '/serviceObject/list', title: 'Объекты', icon: 'storage', class: '', roles: null},
  { path: '/serviceObject/map', title: 'Объекты на карте', icon: 'map', class: '', roles: null},
  { path: '/plannedService/list', title: 'Плановое обслуживание', icon: 'assignment_turned_in', class: '', roles: null },
  { path: '/profile', title: 'Настройки профиля', icon: 'person', class: '', roles: null },
  { path: '/admin/list', title: 'Администрирование', icon: 'admin_panel_settings', class: '', roles: [User.Role.Administrator]}
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  private _systemVersion: string;

  constructor(
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _versionService: VersionService
  ) { }

  ngOnInit() {
    this._versionService.getVersionInfo()
      .retryWhen(errors => errors.delay(20000))
      .subscribe(systemVersion => {
        this._systemVersion = systemVersion;
      });

    this.menuItems = ROUTES.filter(menuItem => menuItem.roles === null
      || _.some(menuItem.roles, (role) => role === this._authenticationService.authenticatedUser.role));
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };

  signOut() {
    this._authenticationService.signOut();
    this._router.navigate(['/account/signin']);
  };
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/main/sidebar/sidebar.component.ts